/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ChatbotTone = {
    Friendly: 'Friendly',
    Neutral: 'Neutral',
    Formal: 'Formal',
    Cold: 'Cold',
    Humorous: 'Humorous'
} as const;
export type ChatbotTone = typeof ChatbotTone[keyof typeof ChatbotTone];


export function instanceOfChatbotTone(value: any): boolean {
    for (const key in ChatbotTone) {
        if (Object.prototype.hasOwnProperty.call(ChatbotTone, key)) {
            if (ChatbotTone[key as keyof typeof ChatbotTone] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ChatbotToneFromJSON(json: any): ChatbotTone {
    return ChatbotToneFromJSONTyped(json, false);
}

export function ChatbotToneFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatbotTone {
    return json as ChatbotTone;
}

export function ChatbotToneToJSON(value?: ChatbotTone | null): any {
    return value as any;
}

export function ChatbotToneToJSONTyped(value: any, ignoreDiscriminator: boolean): ChatbotTone {
    return value as ChatbotTone;
}

